import React, { useEffect, useRef, useState } from "react";
// import { FooterComponents } from "../../components/FooterComponents/FooterComponents";
//import './HomePageScreen.css';
// import 'primeflex/primeflex.css';
// import { Card } from 'primereact/card';
// import { Carousel } from 'primereact/carousel'
import { useParams, useLocation, useHistory  } from "react-router-dom";
import { Breadcrumb, Layout, Menu, Button, PageHeader, Row, Col, Form, Input, Select, Skeleton, notification, Checkbox,Space, Collapse,DatePicker, Modal, Spin, Steps, Divider, Typography } from 'antd';

import { ECatalogNavigation } from "../../components/ECatalogComponents/ECatalogNavigation";
import "./ProductDetailScreen.css";
import { BsCartPlus, BsTrash } from "react-icons/bs";
//import { Item, useCart } from "react-use-cart";
import {  useCart } from "../../Context/CartContext";
import { SearchCatalogItem, GetWolfTemplate, CreateMemorandum, InsertTransactionOrderitem, GetSellerById, GetBudget, ReceiveAddress, SetBudget, GetBudgetByEmpCode, LineApproval} from "../../Services/e-pro/EcatalogService";
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import type { CheckboxProps } from 'antd';
import { useUserContext } from "../../Context/UserContext";
import { GetFiscalYear, MapsDataToProductObject, NotificationAddCartSuccess, NumberFormatter } from "../../Helper/ECatalogHelper";
import Swal from 'sweetalert2'
import { useECatalogContext } from "../../Context/ECatalogContext";
import moment from "moment";
import 'moment/locale/th';
import UnAurthorization from "../UnAuthorizePage/UnAurthorization";
import { GetUserEmpcode } from "../../Services/EmployeeService";
import { GetRunningOrder } from "../../Services/e-pro/RunningOrderService";
import { GetSection } from "../../Services/SectionService";
import { GetEmployeeInfoForCatalog, GetEmployeeInfoForCatalogByEmpId } from "../../Services/e-pro/CatalogMasterDataService";
import { HomeOutlined, UserOutlined } from '@ant-design/icons';

interface Props { responeConfig?: { pathLoading?: string } }
const { Header, Content, Footer, Sider  } = Layout;
const { Option } = Select;
const { Step } = Steps;
const { Text, Link } = Typography;

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 10 },
};
const tailLayout = {
    wrapperCol: { offset: 4, span: 10 },
};
const { Panel } = Collapse;
const { TextArea } = Input;
const { Search } = Input;
type SummaryData = {
    TotalPrice: number,
    TotalPriceNoVat: number,
    VatPrice: number,
    TotalQuantity: number,
}
type FormReceiveProps = {
    ReceiveName?: any;
    Telephone?: any;
    ReceiveDate?: any;
    ReceiveLocation?: any;
    EmployeeCode?: any;
    EmployeeId?: any;
  };
type ProductParams = {
    productId: string;
    // isAutoReport: string;
  };
  type NotificationType = 'success' | 'info' | 'warning' | 'error';
export const CartScreen = (props: Props) => {
    const [userData, setUserData] = useUserContext();
    const history = useHistory();
    const checkEcatalog = useECatalogContext();
    const [productqty, setProductqty] = useState<number>(1);
    const [productItems, setProductItems] = useState<Item[]>();
    const [summaryData, setSummaryData] = useState<SummaryData>({
        TotalPrice: 0,
        TotalPriceNoVat: 0,
        TotalQuantity: 0,
        VatPrice: 0
    });
    const [collapseKey, setCollapseKey] = useState<number>(0);
    const query = new URLSearchParams(useLocation().search);
    const [isCardLoading, setIsCardLoading] = useState<boolean>(false);
    const [openSummaryOrderPopup, setOpenSummaryOrderPopup] = useState(false);
    const [checkAll, setCheckAll] = useState(true);
    const [form] = Form.useForm();
    const [formReceive, setFormReceive] = useState<FormReceiveProps>();
    const [addProductId, setAddProductId] = useState<string>("");
    const [loadingsAddProduct, setLoadingsAddProduct] = useState<boolean>(false);
    const [loadingsSendOrder, setLoadingsSendOrder] = useState<boolean>(false);
    const [userBudget, setUserBudget] = useState<any>();
    const [userBudgetData, setUserBudgetData] = useState<any>();
    const [userBudgetOption, setUserBudgetOption] = useState<any>();
    const [receiverAddress, setReceiverAddress] = useState<any>();
    const [receiverAddressOption, setReceiverAddressOption] = useState<any>();
    const [isAuthorize, setIsAuthorizeo] = useState(true);
    const [isEditECatalog, setIsEditECatalog] = useState(true);
    const [isLoadReceiveAddress, setIsLoadReceiveAddress] = useState(false);
    const [loadingsListCart, setLoadingsListCart] = useState<boolean>(false);
    const [lineApprovalList, setLineApprovalList] = useState<any>();
    const {
        //isEmpty,
        //totalUniqueItems,
        items,
        updateItemQuantity,
        removeItem,
        totalItems,
        addItem,
        removeItems
    } = useCart();
    useEffect(() => {
        if (checkEcatalog.roleData  != null)
        {
            setIsAuthorizeo(checkEcatalog.canAccess);
            setIsEditECatalog(checkEcatalog.canEdit);
        }
        console.log(checkEcatalog);
    }, [checkEcatalog]);
    useEffect(() => {
        //if (productId != null && productId != "")
            //getProducts()
        //setLoadingsListCart(true);

        const updatedItem = items.map((item) => {
                return { ...item, checkItem: checkAll };
          });
        setProductItems(updatedItem);
        processSummary(updatedItem);
          if (updatedItem.filter(x => x.checkItem).length > 0)
            setCollapseKey(1);
          else
          setCollapseKey(0);

        let defaultReceive : FormReceiveProps = {
            ReceiveName: userData.NameTh,
            Telephone: "",
            ReceiveDate: "",
            ReceiveLocation: ""
        }
        //getBudget();
        getListOfBudgetByEmpCode();
        //getReceiverAddress();
        //setFormReceive(defaultReceive);
        setLoadingsListCart(false);
    }, []);

    useEffect(() => {
        getReceiverAddress();
        
    }, [userBudget]);

    useEffect(() => {
        GetLineApproval();
    }, [formReceive]);

    const getListOfBudgetByEmpCode = async() => {
        let year = GetFiscalYear();
        let qyeryData = { EmployeeCode : userData.EmployeeCode, BudgetYear : year}
        let budgetData = await GetBudgetByEmpCode(qyeryData)
        setUserBudgetData(budgetData.data);
        if (budgetData.data !== undefined && budgetData.data.length > 0)
        {
            
            let _userBudgetOptions: { value: string; label: string }[] = [];

            _userBudgetOptions = budgetData.data.map((item: any) => ({
                value: item.EmployeeId,
                label: item.DepartmentName + 
                    (item.DivisionName != undefined ? "-" + item.DivisionName : "") + 
                    (item.SectionName != undefined ? "-" + item.SectionName : "")
            }));
            
            setUserBudgetOption(_userBudgetOptions);

            form.setFieldsValue({selectDeptId: _userBudgetOptions[0].value});
            setUserBudget(budgetData.data[0]);
         
            
        }

    }

    const handleBudgetChange = (value: { value: string; label: React.ReactNode }) => {
        let getUserBudget = userBudgetData.filter(x => x.EmployeeId === value);
        if (getUserBudget.length > 0)
        {
            form.setFieldsValue({selectDeptId: getUserBudget[0].EmployeeId});
            setUserBudget(getUserBudget[0]);
        }
    }

    const getBudget = async () => {
        // let year = moment().add(543, 'year').format('YYYY');
        // if (moment().month() >= 8)
        //     year = (parseInt(year) + 1).toString(); 
        let year = GetFiscalYear();
        let budgetData = await GetBudget({ DepartmentCode: userData.DepartmentCode, DivisionCode: userData.DivisionCode, SectionCode: userData.SectionCode, BudgetYear:year});
        console.log(budgetData);
        if (budgetData.data !== undefined)
        {
            setUserBudget(budgetData.data);
        }
    }

    const setNewBudget = async () => {

        let year = GetFiscalYear();
        let budgetData = await GetBudget({ DepartmentCode: userBudget.DepartmentCode, DivisionCode: userBudget.DivisionCode, SectionCode: userBudget.SectionCode, BudgetYear:year});
        console.log(budgetData);

        if (budgetData.data !== undefined)
        {
            //setUserBudget(budgetData.data);

            let updateBudget = budgetData.data.CurrentBudget - summaryData?.TotalPrice;

            let budgetDataUpdate = await SetBudget({ DepartmentCode: userBudget.DepartmentCode, DivisionCode: userBudget.DivisionCode, SectionCode: 
                userBudget.SectionCode, BudgetYear:year, 
                CurrentBudget: Math.round(updateBudget)});

                //setUserBudget(budgetDataUpdate.data);
                await getListOfBudgetByEmpCode();

        }

    }

    const getReceiverAddress = async() => {
        //let tempSelectUserBudgetInfo = await GetEmployeeInfoForCatalog(userBudget?.EmployeeCode);
        if (userBudget != null)
        {
            setIsLoadReceiveAddress(true);
            //let queryEmpInfo = tempSelectUserBudgetInfo.data;
            let receiveAddress = await ReceiveAddress({ DepartmentCode: userBudget.DepartmentCode, DivisionCode: userBudget.DivisionCode, SectionCode: userBudget.SectionCode });
            console.log(receiveAddress.data);
            setReceiverAddress(receiveAddress.data);
            
            if (receiveAddress.data !== null && receiveAddress.data.length > 0){
                let ddlOption = [];
                let firstItem = receiveAddress.data[0];
                let defaultReceive : FormReceiveProps = {
                    ReceiveName: firstItem.receiverName,
                    Telephone: firstItem.TelMobile,
                    ReceiveDate: "",
                    ReceiveLocation: firstItem.receiverAddress,
                    EmployeeCode: firstItem.EmployeeCode,
                    EmployeeId: firstItem.EmployeeId
                }
               
    
                receiveAddress.data.map((item) => {
                    ddlOption.push({
                        value: item.receiverName,
                        label: item.receiverName
                    })
    
                    if (item.EmployeeId === userData.EmployeeId){
                        defaultReceive = {
                            ReceiveName: item.receiverName,
                            Telephone: item.TelMobile,
                            ReceiveDate: "",
                            ReceiveLocation: item.receiverAddress,
                            EmployeeCode: item.EmployeeCode,
                            EmployeeId: item.EmployeeId
                        }
                        //setFormReceive(defaultReceive);
                    }
                })
    
                setFormReceive(defaultReceive);
    
                setReceiverAddressOption(ddlOption);

            }else{
                setFormReceive(undefined);
                setReceiverAddressOption([]);
            }

            setIsLoadReceiveAddress(false);
        }

    }

     

    const deleteFromCart = (itemdata: any) => {
        removeItem(itemdata.id);

        let itemExist = productItems.findIndex((x) => x.id === itemdata.id);
        if (itemExist > -1){
            productItems.splice(itemExist, 1);
            setProductItems(productItems);
        }

        notification.success({
            message: 'ลบรายการสำเร็จ',
            // description:
            //   'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            placement: "top",
        });

    }

    // const UpdateQuantityToCart = (itemdata: any, quantity: number) => {
    //     updateItemQuantity(itemdata.id, quantity);
    //     setProductItems(items);
    //     const updateCart = productItems.map((item) => {
    //         if (item.id === itemdata.id) {
    //           return {...item, quantity: quantity};
    //         }
    //         return item;
    //       });

    //     setProductItems(updateCart);
    // }



    const handleCheckAll: CheckboxProps['onChange']  = (evt:any) => {

        setCheckAll(!checkAll);
        UpdateStateItem(evt.target.checked, 0);

    }
    const handleCheckItem: CheckboxProps['onChange']  = (evt:any, id) => {

        UpdateStateItem(evt.target.checked, id);

    }

    function UpdateStateItem(isCheck: any, id: any){
        const updatedItem = productItems.map((item) => {
            if (id === 0){
                return { ...item, checkItem: isCheck };
            }else if (item.id === id) {
                return { ...item, checkItem: isCheck };
            }
            return item;

          });
          setProductItems(updatedItem);
          processSummary(updatedItem);
          if (updatedItem.filter(x => x.checkItem).length > 0)
            setCollapseKey(1);
          else
          setCollapseKey(0);
        return updatedItem;
    }
    function calculateTotal(price, quantity){
       //return roundedUpWith2Digit(roundedUpWith2Digit(price * 100/107) * quantity * 107/100);
       return roundedUpWith2Digit(price * quantity);
    }
    const roundedUpWith2Digit = (value: number) => {
        return Math.round(value * 100) / 100;
    }
    const processSummary = (sourceData: any) => {
        let _totalPrice = sourceData?.filter(item => item.checkItem).reduce((sum, current) => sum + calculateTotal(current.price, current.quantity), 0); //ราคารวมสินค้า
        //let _vatPrice = _totalPrice * (7 /100);
        let _priceBeforeVat = _totalPrice * 100/107;//Math.round(_totalPrice * 100/107).toFixed(2); //ราคาสินค้าต่อหน่วยก่อนภาษี
        let _vatPrice = _totalPrice - _priceBeforeVat; //_totalPrice * 7 / 107;//Math.round(_totalPrice * 7 / 107).toFixed(2); //ภาษีมูลค่าเพิ่มต่อหน่วย
       
        let _data: SummaryData = {
            TotalPrice: _totalPrice,//Math.round(_totalPrice).toFixed(2),
            TotalQuantity: sourceData?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0),
            TotalPriceNoVat: _priceBeforeVat ,//_totalPrice - _vatPrice,
            VatPrice: _vatPrice
        }

        setSummaryData(_data)
    }

    const handleOrderProduct = async ()=>{
        
        
        //let sellerInfo = await GetSellerById(1);

        
       await PrcessObjectJson();
    //    setLoadingsSendOrder(true);

    //    setTimeout(() => {
    //         setLoadingsSendOrder(false);

    //         Swal.fire({
    //             title: "ส่งข้อมูลขอซื้อสำเร็จ",
    //             icon: "success",
    //             confirmButtonText: "ตกลง"
    //           }).then((result) => {
    //             /* Read more about isConfirmed, isDenied below */
    //             if (result.isConfirmed) {
    //               setOpenSummaryOrderPopup(false);
    //             } 
    //           })
    //    }, 5000)
    }

    async function GetLineApproval(){
        var templateForm = await GetWolfTemplate("PR");
        if (templateForm != null && userBudget != null)
            {
                // const empResult = await GetUserEmpcode({ EmpCode: userData.EmployeeCode });
                // console.log("result:", empResult);
                //let empResult = await GetEmployeeInfoForCatalog(userData.EmployeeCode);
                let empResult = await GetEmployeeInfoForCatalogByEmpId(userBudget.EmployeeId);

                //let empReceiverResult = await GetEmployeeInfoForCatalog(formReceive.EmployeeCode);
                let empReceiverResult = await GetEmployeeInfoForCatalogByEmpId(formReceive.EmployeeId);

                let objectTemplate = JSON.parse(JSON.stringify(templateForm));
                //let processProductItem = productItems?.filter(item => item.checkItem && item.sellerID === sId);
                //if (productItems?.length > 0){
                    
                  
                    let orderId = "Temp";
                    
                    let requestObject = SetDataToObjectWolf(objectTemplate, productItems, orderId, empResult.data, empReceiverResult.data);
                    let returnData = await LineApproval(requestObject);
                    
                    console.log(returnData);
                    setLineApprovalList(returnData);
                //}

            }
            
    }

    async function PrcessObjectJson(){
        //setIsCardLoading(true);
        
        try{
            setLoadingsSendOrder(true);
            var templateForm = await GetWolfTemplate("PR");
            console.log(templateForm);


            

            if (templateForm != null)
            {
                // const empResult = await GetUserEmpcode({ EmpCode: userData.EmployeeCode });
                // console.log("result:", empResult);
                //let empResult = await GetEmployeeInfoForCatalog(userData.EmployeeCode);
                let empResult = await GetEmployeeInfoForCatalogByEmpId(userBudget.EmployeeId);

                //let empReceiverResult = await GetEmployeeInfoForCatalog(formReceive.EmployeeCode);
                let empReceiverResult = await GetEmployeeInfoForCatalogByEmpId(formReceive.EmployeeId);

                let objectTemplate = JSON.parse(JSON.stringify(templateForm));
                //let processProductItem = productItems?.filter(item => item.checkItem && item.sellerID === sId);
                if (productItems?.length > 0){
                    
                  
                    // let year = moment().add(543, 'year').format('YYYY');
                    // if (moment().month() >= 8)
                    //     year = (parseInt(year) + 1).toString(); 
                    //PO-E{เลขรหัสหน่วยงาน  6 หลัก}{ปีงบประมาณ}- running 4 หลัก
                    //let budgetData = await GetBudget({ DepartmentCode: userData.DepartmentCode, DivisionCode: userData.DivisionCode, SectionCode: userData.SectionCode, BudgetYear:year});
                    //let orderId = `PR-E${userData.DepartmentCode !== "" ? userData.DepartmentCode : "00"}${userData.DivisionCode !== "" ? userData.DivisionCode : "00"}${userData.SectionCode !== "" ? userData.SectionCode : "00"}`;
                    //let orderId = "PR-E000000" + new Date().toDateString();
                    let orderId = `PR-E${userData.DepartmentCode !== "" ? userData.DepartmentCode.padStart(6, '0') : "00".padStart(6, '0')}`;
                    let year = GetFiscalYear()
                    
                    let runningNo = await GetRunningOrder({DocumentType : "PR", Year: year})
                    
                    orderId = orderId + year + `-` + runningNo.data;
                    
                    let requestObject = SetDataToObjectWolf(objectTemplate, productItems, orderId, empResult.data, empReceiverResult.data);
                    let returnData = await CreateMemorandum(requestObject);
                    if (returnData != null && returnData.data != null && returnData.data?.id != 0 && returnData.data?.id != null)
                    {
                        let listOrderItem = [];
                        await setNewBudget();

                        productItems.filter(item => item.checkItem)?.map((item) => {

                           
                            let _priceBeforeVat = item.price * 100/107;
                             let _vatPrice = item.price - _priceBeforeVat;//item.price * 7 /107;

                            let orderItem = {
                                
                                OrderID: orderId,
                                MemoId: returnData.data?.id,
                                ItemID: item.id,
                                OrderTotal: item.quantity,
                                ItemPrice: item.price,
                                ItemVat: parseFloat(_vatPrice.toFixed(2)),
                                ItemBeforVat: parseFloat(_priceBeforeVat.toFixed(2)),
                                CreatedBy: userBudget.EmployeeId.toString(),
                                ModifiedBy: userBudget.EmployeeId.toString()
                            };
                            console.log(orderItem);
                            listOrderItem.push(orderItem);
                        })

                         await InsertTransactionOrderitem(listOrderItem);

                         Swal.fire({
                            title: "ส่งข้อมูลขอซื้อสำเร็จ",
                            //text: returnData.data.documentNo ,
                            icon: "success",
                            confirmButtonText: "ตกลง",
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {

                                // productItems.filter(item => item.checkItem)?.map(x => {
                                //     removeItem(x.id);
                                // });

                                removeItems(productItems.filter(item => item.checkItem).map(x => x.id));
                                setOpenSummaryOrderPopup(false);
                                setLoadingsSendOrder(false);

                                history.push(`/ECatalog`);
                            } 
                        })


                        // Promise.all(productItems.filter(item => item.checkItem)?.map(async (item) => {

                        //     // let _vatPrice = item.price * (7 /100);
                        //     // let _priceBeforeVat = item.price - _vatPrice;

                        //     let _vatPrice = item.price * (7 /107);//item.price * (7 /100);
                        //     let _priceBeforeVat =  item.price * (100/107);//item.price - _vatPrice;

                        //     let orderItem = {
                                
                        //         OrderID: orderId,
                        //         MemoId: returnData.data.id,
                        //         ItemID: item.id,
                        //         SellerID: item.sellerID,
                        //         OrderTotal: item.quantity,
                        //         ItemPrice: item.price,
                        //         ItemVat: _vatPrice,
                        //         ItemBeforVat: _priceBeforeVat,
                        //         OrderStatusID: "",
                        //         TransactionStatus: "",
                        //         CreatedBy: userBudget.EmployeeId.toString(),
                        //         ModifiedBy: userBudget.EmployeeId.toString()
                        //         //CreatedBy: userData.EmployeeId.toString(),
                        //         //ModifiedBy: userData.EmployeeId.toString()
                        //     };
                        //     console.log(orderItem);
                        //     return await InsertTransactionOrderitem(orderItem);
                            
                        // })).then(() => {
                                
                        //     })

                        

                        
                        
                    }
                }


            }
            
            //console.log("after" , templateForm);
        }catch(e){
            console.error("createError", e);
        }

        setLoadingsSendOrder(false);
        //setIsCardLoading(false);

    }

    function SetDataToObjectWolf(templateForm, _productItem, orderId, empResult, empReceiverResult){

        //let filterSelect = receiverAddress.find((item) => item.receiverName === formReceive?.ReceiveName);
        // if (filterSelect != undefined){
        //     let defaultReceive : FormReceiveProps = {
        //         ReceiveName: filterSelect.receiverName,
        //         Telephone: filterSelect.TelNo,
        //         ReceiveDate: "",
        //         ReceiveLocation: filterSelect.receiverAddress
        //     }
        //     setFormReceive(defaultReceive);
        // }

        templateForm.form.map((_template) => {
            let setValue = null;
            switch (_template.template.label) {
                case "เลขที่ใบขอซื้อ":
                    setValue = orderId;
                    break;

                case "วันที่ขอซื้อ":
                    setValue = new Date().toDateString();
                    break;
                case "รายการสินค้าที่ขอซื้อ":
                   //     // set data as table to row array
                let rowItem = [];
                let filterItem = _productItem?.filter(item => item.checkItem);//.reduce((sum, current) => sum + (current.price * current.quantity), 0)
                filterItem?.map((item) => {
                    let subRowItem = [];

                    
                    let _priceBeforeVat =  item.price * (100/107);//item.price - _vatPrice;
                    let _vatPrice = item.price - _priceBeforeVat;//item.price * (7 /107); //item.price * (7 /100);

                    subRowItem.push({ "value": item.sellerID.toString()}); //รหัสผู้ค้า
                    subRowItem.push({ "value": item.sellerName}); //ชื่อผู้ค้า
                    subRowItem.push({ "value": item.catagolyGroupItemName}); //หมวดหมู่สินค้า
                    subRowItem.push({ "value": item.itemId});
                    subRowItem.push({ "value": item.title});
                    subRowItem.push({ "value": item.price.toFixed(2) });//ราคาสินค้าต่อหน่วย //item.price.toString()
                    subRowItem.push({ "value": _vatPrice.toFixed(2) });//ภาษีมูลค่าเพิ่มต่อหน่วย //_vatPrice.toString() NumberFormatter(_vatPrice)
                    subRowItem.push({ "value": _priceBeforeVat.toFixed(2) });//ราคาสินค้าต่อหน่วยก่อนภาษี //_priceBeforeVat.toString() NumberFormatter(_priceBeforeVat) 
                    subRowItem.push({ "value": item.quantity.toString()});
                    subRowItem.push({ "value": item.itemUnit});
                    subRowItem.push({ "value": calculateTotal(item.price, item.quantity).toString() }); //(item.price * item.quantity).toString()});

                    rowItem.push(subRowItem);
                })
                _template.data.row = rowItem;
                    break;
                case "ราคาสินค้า (ก่อนภาษี)":
                    setValue = summaryData.TotalPriceNoVat.toFixed(2); //NumberFormatter(summaryData.TotalPriceNoVat);//summaryData.TotalPriceNoVat.toString();
                    break;
                case "ภาษีมูลค่าเพิ่ม 7%":
                    setValue = summaryData.VatPrice.toFixed(2); //NumberFormatter(summaryData.VatPrice);//summaryData.VatPrice.toString();
                    break;
                case "รวมเป็นเงินทั้งสิ้น":
                    setValue =  summaryData.TotalPrice.toFixed(2); //NumberFormatter(summaryData.TotalPrice);//summaryData.TotalPrice.toString();
                    break;
                case "หน่วยงานผู้ขอซื้อ":
                    setValue = empResult?.DepartmentName;//userData.DepartmentNameTh;
                    break;
                case "ฝ่ายผู้ขอซื้อ":
                    setValue = empResult?.DivisionName;//userData.DivisionNameTh;
                    break;
                case "งานผู้ขอซื้อ":
                    setValue = empResult?.SectionName;
                    break;
                case "ชื่อผู้ขอซื้อ":
                    setValue = userData.NameTh;
                    break;
                case "เบอร์โทรศัพท์ผู้ขอซื้อ":
                    setValue = empResult?.TelMobile;
                    break;
                case "อีเมลผู้ขอซื้อ":
                    setValue = userData.Email;
                    break;
                case "หน่วยงานผู้รับสินค้า":
                    setValue = empReceiverResult?.DepartmentName;
                    break;
                case "ฝ่ายผู้รับสินค้า":
                    setValue = empReceiverResult?.DivisionName;
                    break;
                case "งานผู้รับสินค้า":
                    setValue = empReceiverResult?.SectionName;
                    break;
                case "ชื่อผู้รับสินค้า":
                    setValue = formReceive?.ReceiveName
                    break;
                case "เบอร์โทรศัพท์ผู้รับสินค้า":
                    setValue = formReceive?.Telephone
                    break;
                case "อีเมลผู้รับสินค้า":
                    setValue = empReceiverResult?.Email
                    break;
                case "ที่อยู่จัดส่งสินค้า":
                    setValue = formReceive?.ReceiveLocation
                    break;
                case "กำหนดวันส่งมอบสินค้า":
                    setValue = "";
                    break;
            }
            
            _template.data.value = setValue;

        })
        templateForm.userPrincipalName = userData.Email;
        templateForm.subject = "ใบสรุปรายการขอซื้อ : " + userData.DepartmentNameTh;
        return templateForm;
    }
    useEffect(() =>{
        setLoadingsListCart(true);
        if (items != null){
            checkPriceUpdateData();
        }
        
    }, [items])

    const getUpdateDataByItemId = async(itemIds: any) => {

        const strItemId = itemIds.map(item => item.itemId).join(",");

        let dataJson = {
            searchItem : "",
            Catagoly :0,
            ItemID: strItemId,
            EmployeeId: userData.EmployeeId
            };
        let response = await SearchCatalogItem(dataJson);
        const data = response.data;
        if (data === null) return;
        let productItem: IProductItem;
        let _tempProductItem: IProductItem[] = MapsDataToProductObject(data);
        return _tempProductItem;
    }

    const checkPriceUpdateData = async() => {
        
        const selectItemId = items.map(({ itemId }) => ({ itemId }));
        //console.log("item Id :" + selectItemId);
        if (selectItemId.length == 0) 
        {
            setLoadingsListCart(false);
            return;
        } 

        let _tempProductItem = await getUpdateDataByItemId(selectItemId);

        const updatedItem = items.map((item) => {

            let selectProduct = _tempProductItem.find(nItem => nItem.itemId === item.itemId);
            if (selectProduct !== undefined)
            {
                let itemCheck = checkAll;
                if (item.quantity > selectProduct.itemStock)
                    itemCheck = false;

                return { ...item, checkItem: itemCheck, price : selectProduct.price, itemStock : selectProduct.itemStock };
            }
            else {
                return { ...item, checkItem: checkAll };
            }
        });
        setProductItems(updatedItem);
        processSummary(updatedItem);
        if (updatedItem.filter(x => x.checkItem).length > 0)
            setCollapseKey(1);
        else
        setCollapseKey(0);
        setLoadingsListCart(false);
    }

    const handleAddProduct = async () =>{

        if (addProductId != "")
        {
            setLoadingsAddProduct(true);
            const dataJson = {
                searchItem : "",
                Catagoly :0,
                ItemID: addProductId
              };
            let response = await SearchCatalogItem(dataJson);
            const data = response.data;
            if (data === null || data.length === 0) {
                notification.error({
                    message: 'ไม่พบสินค้า',
                    // description:
                    //   'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
                    placement: "top",
                });
                setLoadingsAddProduct(false);
                return
            }
            let productItem: IProductItem;
            let _tempProductItem: IProductItem[] = MapsDataToProductObject(data);
            productItem = _tempProductItem[0];
            addItem(productItem, 1);
            setAddProductId("");
            // const updatedItem = items.map((item) => {
            //     return { ...item, checkItem: checkAll };
            // });
            // setProductItems(updatedItem);
            // processSummary(updatedItem);
            // if (updatedItem.filter(x => x.checkItem).length > 0)
            //     setCollapseKey(1);
            // else
            // setCollapseKey(0);

            //console.log(totalUniqueItems);
            NotificationAddCartSuccess();
            setLoadingsAddProduct(false);
        }
      
    }
    const handleOpenRequest = async () => {
        let showAlert = true;
        if (userBudget != null)
        {
            if (userBudget?.CurrentBudget > summaryData?.TotalPrice){
                showAlert = false;
                //setOpenSummaryOrderPopup(true);
            }
        }

        const selectItemId = productItems?.filter(item => item.checkItem).map(({ itemId }) => ({ itemId }))
        console.log("item Id :" + selectItemId);
        let _tempProductItem = await getUpdateDataByItemId(selectItemId);
        let _itemsNotEnough = [];
        const checkItem = productItems?.filter(item => item.checkItem).map((item) => {

            let selectProduct = _tempProductItem.find(nItem => nItem.itemId === item.itemId);
            if (selectProduct !== undefined)
            {
                if (selectProduct.itemStock < item.itemStock)
                    _itemsNotEnough.push(selectProduct);
            }
        });
        
        
        if (showAlert)
        {
            Swal.fire({
                title: "วงเงินคงเหลือไม่เพียงพอ",
                icon: "warning",
                confirmButtonText: "ตกลง",
                allowOutsideClick: false,
                allowEscapeKey: false
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    setOpenSummaryOrderPopup(false);
                } 
                })
        }

        if (_itemsNotEnough.length > 0){

            let htmlString = _itemsNotEnough.map(item => {
                return '<div>' + item.itemId + ' : ' + item.title + '</div>'
            });

            Swal.fire({
                title: "มีสินค้าคงเหลือไม่เพียงพอในบางรายการ",
                html: htmlString.join(''),
                icon: "warning",
                confirmButtonText: "ตกลง",
                allowOutsideClick: false,
                allowEscapeKey: false
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    setOpenSummaryOrderPopup(false);
                } 
                })
        }

        if (!showAlert && _itemsNotEnough.length === 0){
            setOpenSummaryOrderPopup(true);
        }
        
    }

    // const handleQuantityChange = (e, itemId) => {
    //     const val = e.target.value;
      
    //     const updatedItems = productItems.map((item) => {
    //       if (item.id === itemId) {
    //         Allow empty string temporarily
    //         if (val === "") {
    //           return { ...item, quantity: "" };
    //         }
      
    //         Only allow positive integers
    //         if (/^\d+$/.test(val)) {
    //           let qty = parseInt(val, 10);
      
    //           Limit to stock
    //           if (qty > item.itemStock) {
    //             qty = item.itemStock;
    //           }
      
    //           updateItemQuantity(itemId, qty);
    //           return { ...item, quantity: qty };
    //         }
    //       }
      
    //       return item;
    //     });
      
    //     setProductItems(updatedItems);
    //   };

    //   const handleQuantityChange = (e, itemId) => {
    //     const val = e.target.value;
      
    //     setProductItems((prevItems) =>
    //       prevItems.map((item) => {
    //         if (item.id === itemId) {
    //           return {
    //             ...item,
    //             quantity: val, // allow "" or raw input
    //           };
    //         }
    //         return item;
    //       })
    //     );
    //   };

    const handleQuantityChange = (e, itemId) => {
        const val = e.target.value;
        let updatedQty = val;
      
        const updatedItems = productItems.map((item) => {
          if (item.id === itemId) {
            // Allow empty string temporarily
            if (val === "") {
              return { ...item, quantity: "" };
            }
      
            // Only allow positive integers
            if (/^\d+$/.test(val)) {
              let qty = parseInt(val, 10);
      
              // Limit to stock
              if (qty > item.itemStock) {
                qty = item.itemStock;
              }
      
              updatedQty = qty.toString(); // Always store as string for consistency
              return { ...item, quantity: updatedQty };
            }
      
            // Disallow invalid input (like "-" or letters)
            return item;
          }
      
          return item;
        });
      
        setProductItems(updatedItems);
      
        // Perform external update only if the value is valid and not empty
        // if (updatedQty !== "" && !isNaN(updatedQty)) {
        //   const parsedQty = parseInt(updatedQty, 10);
        //   if (parsedQty > 0) {
        //     updateItemQuantity(itemId, parsedQty);
        //   }
        // }
      };

      const handleQuantityBlur = (itemId) => {
        const updatedItems = productItems.map((item) => {
          if (item.id === itemId) {
            let qty = parseInt(item.quantity, 10);
      
            if (isNaN(qty) || qty < 1) {
              qty = 1;
            } else if (qty > item.itemStock) {
              qty = item.itemStock;
            }
      
            updateItemQuantity(itemId, qty);
            return { ...item, quantity: qty.toString() };
          }
      
          return item;
        });
      
        setProductItems(updatedItems);
      };

   

    return isAuthorize ? (

        <Layout className="layout">
            <ECatalogNavigation />
            <Content style={{ padding: "0 10px" }}>
                {isCardLoading && (
                    <div className="logo-loading">
                        <img src={props.responeConfig?.pathLoading} alt="loading..." />
                    </div>
                )}
                <div className="cart-layout-content container mt-2">
                    <Space direction="horizontal" style={{marginBottom:"15px"}}>
                        <div style={{border:"1px solid grey", borderRadius:"5px", minWidth: "300px", padding:"5px 10px"}}>
                            <Form layout="horizontal" className="cart-budget-form" form={form}>
                                <Form.Item label={"หน่วยงาน"} name={"selectDeptId"}>
                                <Select className="auto_control_backdate" key={"department"}

                                showSearch
                                placeholder="เลือกหน่วยงาน"
                                optionFilterProp="children"
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={userBudgetOption}
                                onChange={handleBudgetChange}
                            />
                                </Form.Item>
                            </Form>
                            {/* รหัสงบประมาณ <span style={{ float:"right"}}>{ userData?.DepartmentCode}</span> */}
                           
                        </div>
                        <div style={{border:"1px solid grey", borderRadius:"5px", width: "200px", padding:"10px 10px"}}>
                            วงเงินคงเหลือ <span style={{fontWeight: 600, float:"right"}}>{ userBudget != null ? userBudget?.CurrentBudget.toLocaleString('en-US') : "-" }</span>
                        </div>
                        {
                            isEditECatalog && (
                                <div style={{width: "500px"}}>
                                {/* <Search className="cart-inputgroup-add-product" placeholder="input search text" enterButton="เพิ่มสินค้า" loading={loadingsAddProduct} onClick={handleAddProduct} /> */}
                                <Input.Group compact className="cart-inputgroup-add-product">
                                    <Input style={{ width: 'calc(100% - 300px)', borderTopRightRadius: "0px !important", borderBottomRightRadius:"0px !important" }}
                                    placeholder="ใส่รหัสสินค้า" value={addProductId} onChange={(e) => setAddProductId(e.target.value) } allowClear={true} onKeyDown={(e) => {
                                        if (e.keyCode === 13) {
                                            handleAddProduct();
                                        }
                                                
                                    }} />
                                    <Button type="primary" onClick={handleAddProduct} loading={loadingsAddProduct}>เพิ่มสินค้า</Button>
                                </Input.Group>
                            </div>
                            )
                        }
                        
                        
                    </Space>
                    <Space direction="horizontal" style={{marginBottom:"15px", padding:"5px 10px"}}>
                            <label style={{fontWeight: "600"}}>ผู้อนุมัติ : </label>
					<Breadcrumb separator=">">
                    {
                            
                            lineApprovalList?.map((item) => (
                                <Breadcrumb.Item style={{ color: '#000000d9' }}>
                                {/* <UserOutlined /> */}
                                <span>{item.approver?.nameTh}</span>
                                </Breadcrumb.Item>
                            ))
                        }
                       
                    </Breadcrumb>
                        </Space>

                    <div className="cart-header">
                            <div className="cart-header-col-checkbok">
                                {/* <label class="stardust-checkbox">
                                    <input class="stardust-checkbox__input" type="checkbox" aria-checked="false" aria-disabled="false" tabindex="0" role="checkbox" aria-label="Click here to select all products">
                                    <div class="stardust-checkbox__box"></div></label> */}
                                    <Checkbox checked={checkAll} onChange={handleCheckAll}></Checkbox>
                            </div>
                            <div className="cart-header-col-product">สินค้า</div>
                            <div className="cart-header-col-seller">ผู้ค้า</div>
                            <div className="cart-header-col-price">ราคา/ชิ้น</div>
                            <div className="cart-header-col-qty">จำนวน</div>
                            <div className="cart-header-col-totalprice">ราคารวม</div>
                            <div className="cart-header-col-action">แอคชั่น</div>
                    </div>
                    <section className="cart-by-shop">
                        <div className="cart-shop-header" style={{display: "none"}}>
                            <div className="cart-shop-detail">
                                <div className="cart-shop-detail-checkbox">
                                    <Checkbox></Checkbox>
                                </div>
                                <div className="cart-shop-detail-title">
                                    XXX
                                </div>
                            </div>
                        </div>
                        {
                            <section className="cart-item-detail">
                                {
                                    loadingsListCart ? ( <Spin/>) : (

                                         productItems?.map((item, index) => (

                                            <>
                                                <div key={item.id} className="cart-item-row">
                                                    <div className="cart-item-col">
                                                        <div className="cart-item-col-checkbox">
                                                            <Checkbox checked={item.checkItem} onChange={(e) => { handleCheckItem(e, item.id)}} disabled={item.itemStock < item.quantity ? true : false}></Checkbox>
                                                        </div>
                                                        <div className="cart-item-col-product">
                                                            <div className="cart-item-col-product-detail">
                                                                {
                                                                    item.thumbnail != null ? (
                                                                    <a title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                        <img className="cart-item-col-product-image" src={item.defaultthumbnail } alt="product img"></img>
                                                                        {/* item.thumbnail[0].ItemPicPath */}
                                                                    </a>
                                                                    ) : (<></>)
                                                                }

                                                                <div className="cart-item-col-product-title">
                                                                    <a className="cart-item-col-product-title-link" title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                        {item.title}
                                                                    </a>
                                                                    <div>
                                                                        <div style={{fontSize: "14px"}}>รหัสสินค้า : {item.itemId}</div>
                                                                        {item.description}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="cart-item-col-seller">
                                                        { item.sellerName }
                                                        </div>
                                                        <div className="cart-item-col-price">
                                                            {/* {item.price.toFixed(2)} */}
                                                            { NumberFormatter(item.price) }
                                                        </div>
                                                        <div className="cart-item-col-qty">
                                                            <div style={{ display: "flex", alignItems: "center"}}>

                                                                {/* <button className="product-qty-btn btnDecrease" onClick={() => {
                                                                    let itemQuantity = item.quantity - 1;
                                                                    updateItemQuantity(item.id, itemQuantity);
                                                                    const updateCart = productItems.map((_item) => {
                                                                        if (_item.id === item.id) {
                                                                          return {..._item, quantity: itemQuantity};
                                                                        }
                                                                        return _item;
                                                                      });

                                                                    setProductItems(updateCart);

                                                                }}>-</button> */}
                                                                <button
                                                                    className="product-qty-btn btnDecrease"
                                                                    onClick={() => {
                                                                        let itemQuantity = parseInt(item.quantity, 10);

                                                                        // Fallback if quantity is empty or invalid
                                                                        if (isNaN(itemQuantity) || itemQuantity <= 1) {
                                                                        itemQuantity = 1;
                                                                        } else {
                                                                        itemQuantity -= 1;
                                                                        }

                                                                        // Update external quantity (if needed)
                                                                        updateItemQuantity(item.id, itemQuantity);

                                                                        // Update local state
                                                                        const updateCart = productItems.map((_item) => {
                                                                        if (_item.id === item.id) {
                                                                            return { ..._item, quantity: itemQuantity.toString() }; // Keep it as string
                                                                        }
                                                                        return _item;
                                                                        });

                                                                        setProductItems(updateCart);
                                                                    }}
                                                                    >
                                                                    -
                                                                    </button>
                                                                {/* <input className="product-qty-btn txtInput" type="text" readOnly role="spinbutton" aria-live="assertive" defaultValue={item.quantity} value={item.quantity}></input> */}
                                                                <input className="product-qty-btn txtInput" type="number" min={1} max={item.itemStock} role="spinbutton" aria-live="assertive" value={item.quantity}  
                                                                // onChange={e => {
                                                                //     if (e.target.value != "" && e.target.value != "0" && e.target.value.indexOf('-') < 0){
                                                                //         let itemQuantity = parseInt(e.target.value);
                                                                //         if (itemQuantity <= item.itemStock){
                                                                           
                                                                //         }else{
                                                                //             itemQuantity = item.itemStock;
                                                                //         }

                                                                //         updateItemQuantity(item.id, itemQuantity)
                                                                //         const updateCart = productItems.map((_item) => {
                                                                //             if (_item.id === item.id) {
                                                                //             return {..._item, quantity: itemQuantity};
                                                                //             }
                                                                //             return _item;
                                                                //         });

                                                                //         setProductItems(updateCart);
                                                                //     }
                                                                //     else
                                                                //     {
                                                                //         updateItemQuantity(item.id, 1)
                                                                //         const updateCart = productItems.map((_item) => {
                                                                //             if (_item.id === item.id) {
                                                                //             return {..._item, quantity: 1};
                                                                //             }
                                                                //             return _item;
                                                                //         });

                                                                //         setProductItems(updateCart);
                                                                //     }
                                                                // }}  
                                                                onChange={(e) => handleQuantityChange(e, item.id)}
                                                                onBlur={() => handleQuantityBlur(item.id)}
                                                                ></input>
                                                                {/* <button className="product-qty-btn btnIncrease" onClick={() => {
                                                                    let itemQuantity = item.quantity;
                                                                    itemQuantity = itemQuantity < item.itemStock ? itemQuantity + 1 : itemQuantity;
                                                                    updateItemQuantity(item.id, itemQuantity)
                                                                    const updateCart = productItems.map((_item) => {
                                                                        if (_item.id === item.id) {
                                                                          return {..._item, quantity: itemQuantity};
                                                                        }
                                                                        return _item;
                                                                      });

                                                                    setProductItems(updateCart);
                                                                }}>+</button> */}
                                                                <button
                                                                    className="product-qty-btn btnIncrease"
                                                                    onClick={() => {
                                                                        let currentQty = parseInt(item.quantity, 10);

                                                                        // If the value is not a number or less than 1, reset to 1
                                                                        if (isNaN(currentQty) || currentQty < 1) {
                                                                        currentQty = 1;
                                                                        }

                                                                        let itemQuantity = currentQty < item.itemStock ? currentQty + 1 : currentQty;

                                                                        updateItemQuantity(item.id, itemQuantity);

                                                                        const updateCart = productItems.map((_item) => {
                                                                        if (_item.id === item.id) {
                                                                            return { ..._item, quantity: itemQuantity.toString() }; // keep it as string
                                                                        }
                                                                        return _item;
                                                                        });

                                                                        setProductItems(updateCart);
                                                                    }}
                                                                    >
                                                                    +
                                                                    </button>
                                                            </div>
                                                        </div>
                                                        <div className="cart-item-col-totalprice" >
                                                            { 
                                                                //NumberFormatter(item.price * item.quantity) 
                                                                NumberFormatter(calculateTotal(item.price, item.quantity))
                                                            }
                                                        </div>
                                                        <div className="cart-item-col-action">
                                                            <BsTrash onClick={() => deleteFromCart(item)} />
                                                        </div>
                                                    </div>
                                                </div>
                                    {
                                        index != -1 ? (
                                        <div className="cart-item-row-line"></div>
                                        ) : (<></>)
                                    }
                                            </>

                                         ))

                                    )
                                    }


                                </section>

                        }


                    </section>
                    <section className="cart-to-dept">

                    </section>
                    <section className="cart-summarytotal">
                        <div className="cart-item-row" style={{marginTop:"10px", marginBottom: "10px"}}>
                            <div className="cart-item-col">
                                <div className="cart-item-col-checkbox">
                                </div>

                                <div className="cart-item-col-product">
                                    ราคาสุทธิ
                                </div>
                                <div className="cart-item-col-seller"></div>
                                <div className="cart-item-col-price">

                                </div>
                                <div className="cart-item-col-qty">
                                    {/* {
                                        productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0)
                                    } */}
                                    { summaryData?.TotalQuantity } ชิ้น
                                </div>
                                <div className="cart-item-col-totalprice">
                                    {/* {
                                        (productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + (current.price * current.quantity), 0))?.toFixed(2)
                                    } */}
                                     { NumberFormatter(summaryData?.TotalPrice) }
                                </div>
                                <div className="cart-item-col-action">

                                </div>
                                </div>
                        </div>

                    </section>
                    <Collapse collapsible="header"  className="cart-to-dept" expandIconPosition="end" activeKey={collapseKey}
                    onChange={() => { collapseKey == 0 ? setCollapseKey(1) : setCollapseKey(0); }}>
                         
                        <Panel header="ระบุชื่อผู้รับสินค้า และสถานที่รับสินค้า" key="1" style={{backgroundColor: "#c95558"}}>
                        <Spin spinning={isLoadReceiveAddress}>
                        <Row gutter={[8, 8]}>
                            <Col span={8} >
                                ระบุชื่อผู้รับสินค้า
                                <Select options={receiverAddressOption} onChange={(value: { value: string; label: React.ReactNode }) => {
                                    console.log(value);

                                    let filterSelect = receiverAddress.find((item) => item.receiverName === value);
                                    if (filterSelect != undefined){
                                        let defaultReceive : FormReceiveProps = {
                                            ReceiveName: filterSelect.receiverName,
                                            Telephone: filterSelect.TelMobile,
                                            ReceiveDate: "",
                                            ReceiveLocation: filterSelect.receiverAddress,
                                            EmployeeCode: filterSelect.EmployeeCode,
                                            EmployeeId: filterSelect.EmployeeId
                                        }
                                        setFormReceive(defaultReceive);
                                    }


                                    setFormReceive(formReceive => ({ ...formReceive, ReceiveName: value }))
                                    }} value={formReceive?.ReceiveName}
                                />
                            </Col>
                            <Col span={8}>
                                เบอร์โทรศัพท์
                                <Input onChange={(e) =>  setFormReceive(formReceive => ({ ...formReceive, Telephone: e.target.value }))} value={formReceive?.Telephone} />
                            </Col>
                            <Col span={8}>
                                วันส่งมอบ
                                <Input disabled={true} value={"ตามเงื่อนไขวันที่ส่งมอบในสัญญา"} />
                            
                                {/* <DatePicker onChange={(date: any, dateString: string) => {
                                    //console.log(date);
                                     setFormReceive(formReceive => ({ ...formReceive, ReceiveDate: date }))
                                }} /> */}
                            </Col>
                            <Col span={24}>
                                สถานที่จัดส่งสินค้า
                                <TextArea rows={4} onChange={(e) => {
                                     setFormReceive(formReceive => ({ ...formReceive, ReceiveLocation: e.target.value }))
                                }} value={formReceive?.ReceiveLocation} />
                            </Col>
                        </Row>
                        </Spin>
                        
                        </Panel>
                       
                    </Collapse>
                    <section className="cart-total">
                        <div className="cart-total-checkout container">
                            <div className="row">
                                <div className="col-6 cart-total-label">ราคาสุทธิสินค้าไม่รวมภาษี</div>
                                <div className="col-6 cart-total-content">
                                { NumberFormatter(summaryData?.TotalPriceNoVat) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 cart-total-label">ภาษีมูลค่าเพิ่ม 7%</div>
                                <div className="col-6 cart-total-content">
                                    { NumberFormatter(summaryData?.VatPrice) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 cart-total-label">จำนวนรวมทั้งสิ้น</div>
                                <div className="col-6 cart-total-content">
                                    { NumberFormatter(summaryData?.TotalPrice) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-right"  style={{textAlign: "right"}}>
                                <Button type="primary" htmlType="button" className="cart-action-buy-button" onClick={() => handleOpenRequest()} disabled={
                                    productItems?.filter(item => item.checkItem).length > 0 && (formReceive !== undefined && formReceive?.EmployeeCode !== undefined) ? false : true
                                }>
                                    ส่งขออนุมัติสั่งซื้อ
                                </Button>
                                {/* <button className="btn btn-danger btn-sm">ส่งขออนุมัติสั่งซื้อ</button> */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Modal
                    title="สรุปรายการขอซื้อสินค้า"
                    centered
                    visible={openSummaryOrderPopup}
                    //onOk={() => setOpenSummaryOrderPopup(false)}
                    //onCancel={() => setOpenSummaryOrderPopup(false)}
                    width={1000}
                    closable={false}
                    maskClosable={false}
                    className="cart-summary-modal"
                    footer={[
                        <Button key="modalback" className="cart-modal-btn btn-not-accept" onClick={() => setOpenSummaryOrderPopup(false)} disabled={loadingsSendOrder}>
                          ไม่ยืนยัน
                        </Button>,
                        <Button key="modalsubmit" className="cart-modal-btn btn-accept" type="primary" loading={loadingsSendOrder} onClick={() => handleOrderProduct()}>
                          ยืนยัน
                        </Button>
                      ]}
                >
                    <div className="cart-header">
                            
                            <div className="cart-header-col-product">สินค้า</div>
                            <div className="cart-header-col-seller">ผู้ค้า</div>
                            <div className="cart-header-col-price">ราคา/ชิ้น</div>
                            <div className="cart-header-col-qty">จำนวน</div>
                            <div className="cart-header-col-totalprice">ราคารวม</div>
                    </div>
                    <section className="cart-item-detail">
                                {
                                         productItems?.filter(item => item.checkItem)?.map((item, index) => (

                                            <>
                                                <div key={item.id} className="cart-item-row">
                                                    <div className="cart-item-col">
                                                        
                                                        <div className="cart-item-col-product">
                                                            <div className="cart-item-col-product-detail">
                                                                {
                                                                    item.thumbnail != null ? (
                                                                    <a title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                        <img className="cart-item-col-product-image" src={item.defaultthumbnail } alt="product img"></img>
                                                                        {/* item.thumbnail[0].ItemPicPath */}
                                                                    </a>
                                                                    ) : (<></>)
                                                                }

                                                                <div className="cart-item-col-product-title">
                                                                    <a className="cart-item-col-product-title-link" title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                        {item.title}
                                                                    </a>
                                                                    <div>
                                                                        <div style={{fontSize: "14px"}}>รหัสสินค้า : {item.itemId}</div>
                                                                        {item.description}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="cart-item-col-seller">
                                                            { item.sellerName }
                                                        </div>
                                                        <div className="cart-item-col-price">
                                                            {/* {item.price.toFixed(2)} */}
                                                            { NumberFormatter(item.price) }
                                                        </div>
                                                        <div className="cart-item-col-qty">
                                                            { item.quantity }
                                                        </div>
                                                        <div className="cart-item-col-totalprice">
                                                            { 
                                                                 NumberFormatter(calculateTotal(item.price, item.quantity))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                    {
                                        index != -1 ? (
                                        <div className="cart-item-row-line"></div>
                                        ) : (<></>)
                                    }
                                            </>

                                         ))
                                    }


                                </section>
                     <section className="cart-summarytotal">
                        <div className="cart-item-row" style={{marginTop:"10px", marginBottom: "10px"}}>
                            <div className="cart-item-col">

                                <div className="cart-item-col-product">
                                    ราคาสุทธิ
                                </div>
                                <div className="cart-item-col-seller">

                                </div>
                                <div className="cart-item-col-price">

                                </div>
                                <div className="cart-item-col-qty">
                                    {/* {
                                        productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0)
                                    } */}
                                    { summaryData?.TotalQuantity } ชิ้น
                                </div>
                                <div className="cart-item-col-totalprice" style={{ justifyContent: "flex-end"}}>
                                    {/* {
                                        (productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + (current.price * current.quantity), 0))?.toFixed(2)
                                    } */}
                                     { NumberFormatter(summaryData?.TotalPrice) }
                                </div>
                                </div>
                        </div>

                    </section>
                    <section >
                        <div className="container" style={{ paddingRight: "20px"}}>
                            <div className="row">
                                <div className="col-6 cart-total-label">ราคาสุทธิสินค้าไม่รวมภาษี</div>
                                <div className="col-6 cart-total-content">
                                { NumberFormatter(summaryData?.TotalPriceNoVat) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 cart-total-label">ภาษีมูลค่าเพิ่ม 7%</div>
                                <div className="col-6 cart-total-content">
                                    { NumberFormatter(summaryData?.VatPrice) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 cart-total-label-red">จำนวนรวมทั้งสิ้น</div>
                                <div className="col-6 cart-total-content-red">
                                    { NumberFormatter(summaryData?.TotalPrice) } บาท
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="container mt-4 px-4" style={{fontSize: "16px", fontWeight: "600"}}>
                        <div className="row">
                            <div className="col-2">ชื่อผู้รับสินค้า :</div>
                            <div className="col-4" style={{fontWeight: "normal"}}>
                                {formReceive?.ReceiveName}
                            </div>
                            <div className="col-2">เบอร์โทร :</div>
                            <div className="col-4" style={{fontWeight: "normal"}}>
                                { formReceive?.Telephone}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2">สถานที่จัดส่งสินค้า :</div>
                            <div className="col-10" style={{fontWeight: "normal"}}>
                                {formReceive?.ReceiveLocation}
                            </div>
                        </div>
                    </section>
                </Modal>
            </Content>
        </Layout>
    ) : (  <UnAurthorization/>);
};